import './App.scss';
import { BrowserRouter as Router, Routes, Route,Outlet } from 'react-router-dom';
import Home from './pages/Home/Home';
import Navbar from './pages/components/Navbar/navbar';
import Monthly from './pages/SubPages/PanchangSubPages/Monthly/Monthly';
import Dainik from './pages/SubPages/PanchangSubPages/Dainik/Dainik';
import Bengali from './pages/SubPages/PanchangSubPages/Bengali/Bengali';
import English from './pages/SubPages/PanchangSubPages/English/English';
import Iskcon from './pages/SubPages/PanchangSubPages/Iskcon/Iskcon';
import Naksatra from './pages/SubPages/PanchangSubPages/Naksatra/Naksatra';
import Chandrabalam from './pages/SubPages/PanchangSubPages/Chandrabalam/Chandrabalam';


import PlanetPosition from './pages/SubPages/PlanetSubPages/PlanetPosition/PlanetPosition';
import Kundali from './pages/SubPages/JyotishSubpages/Kundali/Kundali';
import DoGhati from './pages/SubPages/MuhuratSubPages/DoGhatiMuhurat/DoGhati';
import Ekadashi from './pages/SubPages/VratSubPages/ekadashi/ekadashi';
import LuckyNum from './pages/SubPages/NumerologySubpages/LuckyNumber/LuckyNumber';
import HinduFest from './pages/SubPages/FestivalSubPages/HinduFestivals/HinduFest';

import Hindu from './pages/SubPages/CalenderSubPages/Hindu/Hindu';
import Indian from './pages/SubPages/CalenderSubPages/Indian/Indian';
import Tamil from './pages/SubPages/CalenderSubPages/Tamil/Tamil';
import Malyalam from './pages/SubPages/CalenderSubPages/Malyalam/Malyalam';
import Odia from './pages/SubPages/CalenderSubPages/Odia/Odia';
import Bengali_c from './pages/SubPages/CalenderSubPages/Bengali/Bengali';
import Gujrati from './pages/SubPages/CalenderSubPages/Gujrati/Gujrati';
import Marathi from './pages/SubPages/CalenderSubPages/Marathi/Marathi';
import Telegu from './pages/SubPages/CalenderSubPages/Telegu/Telegu';
import Iskon from './pages/SubPages/CalenderSubPages/Iskon/Iskon';
import Sankranti from './pages/SubPages/CalenderSubPages/Sankranti/Sankranti';
import Shardiya from './pages/SubPages/CalenderSubPages/Shardiya/Shardiya';
import Diwali from './pages/SubPages/CalenderSubPages/Diwali/Diwali';
import Durga from './pages/SubPages/CalenderSubPages/DurgaPuja/Durga';
import Chaitra from './pages/SubPages/CalenderSubPages/ChitraNavratri/Chaitra';


import Choghadiya from './pages/SubPages/MuhuratSubPages/Choghadiya/Choghadiya';
import SubhoHora from './pages/SubPages/MuhuratSubPages/SubhoHora/SubhoHora';
import Lagna from './pages/SubPages/MuhuratSubPages/LagnaTable/Lagna';
import Gowri from './pages/SubPages/MuhuratSubPages/Gowri/Gowri';
import Jain from './pages/SubPages/MuhuratSubPages/Jain/Jain';
import Rahita from './pages/SubPages/MuhuratSubPages/Rahita/Rahita';
import Rahu from './pages/SubPages/MuhuratSubPages/RahuKala/Rahu';
import Abhijit from './pages/SubPages/MuhuratSubPages/Abhijit/Abhijit';
import Auspicious from './pages/SubPages/MuhuratSubPages/Auspicious/Auspicious';
import Vivah from './pages/SubPages/MuhuratSubPages/Vivah/Vivah';
import Griha from './pages/SubPages/MuhuratSubPages/GrihaPravesh/Griha';
import Property from './pages/SubPages/MuhuratSubPages/Property/Property';
import Vehicle from './pages/SubPages/MuhuratSubPages/Vehicle/Vehicle';
import Subho from './pages/SubPages/MuhuratSubPages/SubhoDates/Subho';


import Purnima from './pages/SubPages/VratSubPages/PurnimaDates/Purnima';
import Amavasya from './pages/SubPages/VratSubPages/Amavasya/Amavasya';
import Chandra from './pages/SubPages/VratSubPages/ChandraDarshan/Chandra';
import MasikShiv from './pages/SubPages/VratSubPages/MasikShiv/MasikShiv';
import Pradosham from './pages/SubPages/VratSubPages/Pradosham/Pradosham';
import Sankasthi from './pages/SubPages/VratSubPages/Sankasthi/Sankasthi';
import Vinayaka from './pages/SubPages/VratSubPages/Vinayaka/Vinayaka';
import SankrantiDates from './pages/SubPages/VratSubPages/SankrantiDates/SankrantiDates';
import Satya from './pages/SubPages/VratSubPages/Satya/Satya';
import MasikDurga from './pages/SubPages/VratSubPages/MasikDurga/MasikDurga';
import MasikKala from './pages/SubPages/VratSubPages/MasikKala/MasikKala';
import Krathigai from './pages/SubPages/VratSubPages/Krathigai/Krathigai';
import Janmastami from './pages/SubPages/VratSubPages/Janmastami/Janmastami';
import Skanda from './pages/SubPages/VratSubPages/Skanda/Skanda';
import IskonVrat from './pages/SubPages/VratSubPages/IskonVrat/IskonVrat';
import VratKotha from './pages/SubPages/VratSubPages/vratKatha/VratKatha';
import Shradha from './pages/SubPages/VratSubPages/Shraddha/Shraddha';


import JanmaKundali from './pages/SubPages/JyotishSubpages/JanmaKundali/JanmaKundali';
import Match from './pages/SubPages/JyotishSubpages/HoroscopeMatch/Match';
import PanchaPaki from './pages/SubPages/JyotishSubpages/PanchaPaki/PanchaPaki';
import Rashifal from './pages/SubPages/JyotishSubpages/Rashifal/Rashifal';
import Moonsign from './pages/SubPages/JyotishSubpages/Moonsign/Moonsign';
import BirthStar from './pages/SubPages/JyotishSubpages/BirthStar/BirthStar';
import Mongol from './pages/SubPages/JyotishSubpages/MongolDasha/Mongol';
import Kalsarpa from './pages/SubPages/JyotishSubpages/Kalsarpa/Kalsarpa';
import BabyName from './pages/SubPages/JyotishSubpages/BabyName/BabyName';
import JanmaLagna from './pages/SubPages/JyotishSubpages/JanmaLagna/JanmaLagna';
import Sunsign from './pages/SubPages/JyotishSubpages/Sunsign/Sunsign';
import Shraddha from './pages/SubPages/JyotishSubpages/Shraddha/Shraddha';
import Sahasra from './pages/SubPages/JyotishSubpages/Sahasra/Sahasra';
import Combustion from './pages/SubPages/PlanetSubPages/Combustion/Combustion';
import Eclipse from './pages/SubPages/PlanetSubPages/Eclipse/Eclipse';
import Lunar from './pages/SubPages/PlanetSubPages/Lunar/Lunar';
import Transit from './pages/SubPages/PlanetSubPages/PlanetTransit/Transit';
import Retro from './pages/SubPages/PlanetSubPages/Retrograde/Retro';
import Solar from './pages/SubPages/PlanetSubPages/Solar/Solar';
import Season from './pages/SubPages/PlanetSubPages/Season/Season';
import Summer from './pages/SubPages/PlanetSubPages/Summer/Summer';
import Winter from './pages/SubPages/PlanetSubPages/Winter/Winter';


import Unlucky from './pages/SubPages/NumerologySubpages/UnluckyNumbers/Unlucky';
import Chinese from './pages/SubPages/NumerologySubpages/Chinese/Chinese';
import Path from './pages/SubPages/NumerologySubpages/LifePath/Path';
import Destiny from './pages/SubPages/NumerologySubpages/Destiny/Destiny';
import Birth from './pages/SubPages/NumerologySubpages/Birth/Birth';
import Soul from './pages/SubPages/NumerologySubpages/Soul/Soul';
import Name from './pages/SubPages/NumerologySubpages/Name/Name';
import Balance from './pages/SubPages/NumerologySubpages/Balance/Balance';
import Losu from './pages/SubPages/NumerologySubpages/LoSu/Losu';
import Kua from './pages/SubPages/NumerologySubpages/Kua/Kua';
import Vishnu from './pages/SubPages/FestivalSubPages/24Vishnu/24Vishnu';
import Dash from './pages/SubPages/FestivalSubPages/Dashavatra/Dash';
import TamilFest from './pages/SubPages/FestivalSubPages/TamilFest/TamilFest';
import MalyalamFest from './pages/SubPages/FestivalSubPages/MalyalamFest/MalyalamFest';
import SankrantiFest from './pages/SubPages/FestivalSubPages/SankrantiFest/SankrantiFest';
import NavDurga from './pages/SubPages/FestivalSubPages/NavDurga/NavDurga';
import PujaVidhi from './pages/SubPages/FestivalSubPages/PujaVidhi/PujaVidhi';
import Deities from './pages/SubPages/FestivalSubPages/Deities/Deities';
import Gurus from './pages/SubPages/FestivalSubPages/Gurus/Gurus';
import TopFest from './pages/SubPages/FestivalSubPages/Top10Festivals/TopFest';
import Conjunction from './pages/SubPages/PlanetSubPages/Conjuction/Conjunction';
import Initial from './pages/SubPages/JyotishSubpages/NameInitial/initial';
import Basic from './pages/SubPages/JyotishSubpages/JanmaKundali/Basic/Basic';
import LeftBar from './pages/components/LeftBar/LeftBar';
import BasicDetails from './pages/SubPages/JyotishSubpages/JanmaKundali/Calculations/BasicDetails/BasicDetails';
import PlanetPos from './pages/SubPages/JyotishSubpages/JanmaKundali/Calculations/PlanetPos/PlanetPos';
import Chalit from './pages/SubPages/JyotishSubpages/JanmaKundali/Calculations/ChalitTable/Chalit';
import Pras from './pages/SubPages/JyotishSubpages/JanmaKundali/Calculations/Pras/Pras';
import Life from './pages/SubPages/JyotishSubpages/JanmaKundali/Predictions/Life/Life';
import Love from './pages/SubPages/JyotishSubpages/JanmaKundali/Predictions/Love/Love';
import Career from './pages/SubPages/JyotishSubpages/JanmaKundali/Predictions/Career/Career';
import Nature from './pages/SubPages/JyotishSubpages/JanmaKundali/Predictions/Nature/Nature';
import Ashtak from './pages/SubPages/JyotishSubpages/JanmaKundali/Calculations/Ashtak/Ashtak';
import Aspect from './pages/SubPages/JyotishSubpages/JanmaKundali/Calculations/PlanetAspect/Aspect';
import Arti from './pages/SubPages/LyricsSubPages/Aarti/Arti.jsx';

import AstroBlog from './pages/Blog/Blog';
import Admin from './pages/Admin/Admin';

//for animation
import { useEffect, useState } from 'react';
import LogoSplash from './pages/components/LogoSplash/Logo'; // you’ll create this
import PrivacyPolicy from './pages/Policy/Policy';
import TermsAndConditions from './pages/Terms/Terms';
import RefundPolicy from './pages/Refund/Refund';
import Chart from './pages/Chart/Chart';
import VimshottariLinks from './pages/SubPages/JyotishSubpages/JanmaKundali/Dasha/vim/vim';
import Mdad from './pages/SubPages/JyotishSubpages/JanmaKundali/Dasha/vim/vimSubPage/MDAD/mdad';
import CharDasha from './pages/SubPages/JyotishSubpages/JanmaKundali/Dasha/char/char';
import YoginiDasha from './pages/SubPages/JyotishSubpages/JanmaKundali/Dasha/yogini/yogini';
import NumberPage from './pages/SubPages/JyotishSubpages/JanmaKundali/Num/Num';
import Adpd1 from './pages/SubPages/JyotishSubpages/JanmaKundali/Dasha/vim/vimSubPage/Adpd1/Adpd1';
import Adpd2 from './pages/SubPages/JyotishSubpages/JanmaKundali/Dasha/vim/vimSubPage/Adpd2/Adpd2';
import Adpd3 from './pages/SubPages/JyotishSubpages/JanmaKundali/Dasha/vim/vimSubPage/Adpd3/Adpd3';
import Adpd4 from './pages/SubPages/JyotishSubpages/JanmaKundali/Dasha/vim/vimSubPage/Adpd4/Adpd4';
import Adpd5 from './pages/SubPages/JyotishSubpages/JanmaKundali/Dasha/vim/vimSubPage/Adpd5/Adpd5';
import Sd1 from './pages/SubPages/JyotishSubpages/JanmaKundali/Dasha/vim/vimSubPage/Sd1/Sd1';
import Sd2 from './pages/SubPages/JyotishSubpages/JanmaKundali/Dasha/vim/vimSubPage/sd2/Sd2';
import Sd3 from './pages/SubPages/JyotishSubpages/JanmaKundali/Dasha/vim/vimSubPage/Sd3/Sd3';
import Sd4 from './pages/SubPages/JyotishSubpages/JanmaKundali/Dasha/vim/vimSubPage/Sd4/Sd4';
import About from './pages/About/About';
import LoveHoro from './pages/LoveHoroscope/LoveHoro';
import Learn from './pages/LearnAstro/Learn';
import Gemstone from './pages/Gemstone/Gemstone';
import Friends from './pages/SubPages/JyotishSubpages/JanmaKundali/Calculations/Friendship/Friends';
import Madhya from './pages/SubPages/JyotishSubpages/JanmaKundali/Calculations/VabMadhya/Madhya';
import ShadBhav from './pages/SubPages/JyotishSubpages/JanmaKundali/Calculations/ShadBhav/ShadBhav';
import Schedule from './pages/Admin/schedule/schedule';
import Ephemeris from './pages/Ephemeris/Ephemeris';
import FeedbackTestimonial from './pages/Admin/FeedbackTest/FeedbackTest';
import AllChart from './pages/SubPages/JyotishSubpages/JanmaKundali/Calculations/D1-to-D16/charts';
import TransitToday from './pages/SubPages/JyotishSubpages/JanmaKundali/Calculations/TransitToday/TransitToday';
import Careerr from './pages/Career/Career';
import ExtendedEphemeris from './pages/ExtendedEphemeris/ExtendedEphemeris.jsx';
import NumReport from './pages/SubPages/NumerologySubpages/Report/NumReport.jsx';
import Personal from './pages/SubPages/NumerologySubpages/PersonalYear/Personal.jsx';

//ends here

function App() {

//for the splash effect on initial load-->
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShowSplash(false), 3000); // 3 seconds splash
    return () => clearTimeout(timer);
  }, []);

  //ends here

const Layout = () => {
  return (
    <div className="layout">
      <div className="layout-flex">
        <LeftBar />
        <div className="content-wrapper">
          <Outlet />
        </div>
      </div>
    </div>
  );
};



//for margin in both side of every page
const LayoutWithMargin = () => {
  return (
    <div className="homee">
      <div className="borderr">
        <Outlet />
      </div>
    </div>
  );
};





  return (
    <div className="App">
       {showSplash ? (
        <LogoSplash />
      ) : (
      <Router>
      <Navbar />
        <Routes>
          <Route element={<LayoutWithMargin />}>
          <Route path="/" element={<Home />} />


          <Route path="/panchang/monthly" element={<Monthly />} />
          <Route path="/panchang/dainik" element={<Dainik />} />
          <Route path="/panchang/bengali" element={<Bengali />} />
          <Route path="/panchang/english" element={<English />} />
          <Route path="/panchang/iskcon" element={<Iskcon />} />
          <Route path="/panchang/naksatra" element={<Naksatra />} />
          <Route path="/panchang/chandrabalam" element={<Chandrabalam />} />
          



          <Route path="/calender/hindu" element={<Hindu/>} />
          <Route path="/calender/indian" element={<Indian/>} />
          <Route path="/calender/tamil" element={<Tamil/>} />
          <Route path="/calender/malyalam" element={<Malyalam/>} />
          <Route path="/calender/odia" element={<Odia/>} />
          <Route path="/calender/bengali" element={<Bengali_c/>} />
          <Route path="/calender/gujrati" element={<Gujrati/>} />
          <Route path="/calender/marathi" element={<Marathi/>} />
          <Route path="/calender/telegu" element={<Telegu/>} />
          <Route path="/calender/iskon" element={<Iskon/>} />
          <Route path="/calender/sankranti" element={<Sankranti/>} />
          <Route path="/calender/shardiya" element={<Shardiya/>} />
           <Route path="/calender/diwali" element={<Diwali/>} />
           <Route path="/calender/durgapuja" element={<Durga/>} />
           <Route path="/calender/chaitranavaratri" element={<Chaitra/>} />


          <Route path="/planets/planetary-positions" element={<PlanetPosition/>} />
          <Route path="/planets/combustion" element={<Combustion/>} />
          <Route path="/planets/eclipse-dates" element={<Eclipse/>} />
           <Route path="/planets/lunar-eclipse" element={<Lunar/>} />
           <Route path="/planets/planet-transit" element={<Transit/>} />
            <Route path="/planets/retrograde" element={<Retro/>} />
            <Route path="/planets/solar-eclipse" element={<Solar/>} />
            <Route path="/planets/indian-seasons" element={<Season/>} />
            <Route path="/planets/summer-solstice" element={<Summer/>} />
            <Route path="/planets/winter-solstice" element={<Winter/>} />
            <Route path="/planets/conjunction" element={<Conjunction/>} />



           <Route path="/jyotish/kundali" element={<Kundali/>} />
            <Route path="/jyotish/janma-kundali" element={<JanmaKundali/>} />
            <Route path="/jyotish/matchmaking" element={<Match/>} />
            <Route path="/jyotish/pancha-paki" element={<PanchaPaki/>} />
            <Route path="/jyotish/rashifal" element={<Rashifal/>} />
            <Route path="/jyotish/moonsign" element={<Moonsign/>} />
            <Route path="/jyotish/birthstar" element={<BirthStar/>} />
            <Route path="/jyotish/mangal-dasha" element={<Mongol/>} />
            <Route path="/jyotish/kalsarpa-yoga" element={<Kalsarpa/>} />
            <Route path="/jyotish/baby-name-finder" element={<BabyName/>} />
            <Route path="/jyotish/name-initials" element={<Initial/>} />
            <Route path="/jyotish/janma-lagna" element={<JanmaLagna/>} />
            <Route path="/jyotish/sunsign" element={<Sunsign/>} />
            <Route path="/jyotish/sraddha-calculator" element={<Shraddha/>} />
            <Route path="/jyotish/sahasra-chandradaya" element={<Sahasra/>} />


           
          <Route path="/muhurat/do-ghati-muhurat" element={<DoGhati/>} />
          <Route path="/muhurat/chogadiya" element={<Choghadiya/>} />
          <Route path="/muhurat/subho-hora" element={<SubhoHora/>} />
          <Route path="/muhurat/lagna-table" element={<Lagna/>} />
          <Route path="/muhurat/gowri-panchangam" element={<Gowri/>} />
          <Route path="/muhurat/jain-pachchakkan" element={<Jain/>} />
          <Route path="/muhurat/punchake-rahita" element={<Rahita/>} />
          <Route path="/muhurat/rahu-kala" element={<Rahu/>} />
           <Route path="/muhurat/abhijit-muhurat" element={<Abhijit/>} />
            <Route path="/muhurat/auspicious-yoga" element={<Auspicious/>} />
             <Route path="/muhurat/vivah-muhurat" element={<Vivah/>} />
             <Route path="/muhurat/griha-pravesh" element={<Griha/>} />
             <Route path="/muhurat/property-purchase" element={<Property/>} />
              <Route path="/muhurat/vehicle-purchase" element={<Vehicle/>} />
               <Route path="/muhurat/subha-dates" element={<Subho/>} />



          <Route path="/vrat/ekadashi" element={<Ekadashi />} />
          <Route path="/vrat/purnima-dates" element={<Purnima/>} />
          <Route path="/vrat/amavasya-dates" element={<Amavasya/>} />
          <Route path="/vrat/chandra-darshan" element={<Chandra/>} />
          <Route path="/vrat/masik-shivaratri" element={<MasikShiv/>} />
          <Route path="/vrat/pradosham-dates" element={<Pradosham/>} />
          <Route path="/vrat/sankashti-chaturthi" element={<Sankasthi/>} />
          <Route path="/vrat/vinayaka-chaturthi" element={<Vinayaka/>} />
          <Route path="/vrat/sankranti-dates" element={<SankrantiDates/>} />
          <Route path="/vrat/satyanarayana-puja" element={<Satya/>} />
          <Route path="/vrat/masik-durgaashtami" element={<MasikDurga/>} />
          <Route path="/vrat/masik-kalashtami" element={<MasikKala/>} />
          <Route path="/vrat/krathigai-dates" element={<Krathigai/>} />
          <Route path="/vrat/janmashtami-dates" element={<Janmastami/>} />
          <Route path="/vrat/skanda-sashthi" element={<Skanda/>} />
          <Route path="/vrat/iskon-ekadashi" element={<IskonVrat/>} />
          <Route path="/vrat/vrat-katha" element={<VratKotha/>} />
          <Route path="/vrat/shraddha-dates" element={<Shradha/>} />

         



          <Route path="/numerology/luckynum" element={<LuckyNum/>} />
           <Route path="/numerology/unlucky" element={<Unlucky/>} />
            <Route path="/numerology/chinese-lucky" element={<Chinese/>} />
             <Route path="/numerology/life-path" element={<Path/>} />
              <Route path="/numerology/destiny" element={<Destiny/>} />
              <Route path="/numerology/birth" element={<Birth/>} />
              <Route path="/numerology/soul" element={<Soul/>} />
              <Route path="/numerology/name" element={<Name/>} />
              <Route path="/numerology/balance" element={<Balance/>} />
              <Route path="/numerology/lo-shu-grid" element={<Losu/>} />
              <Route path="/numerology/kua" element={<Kua/>} />
              <Route path="/numerology/report" element={<NumReport/>} />
              <Route path="/numerology/personalyear" element={<Personal/>} />



           <Route path="/festival/hindufest" element={<HinduFest/>} />
           <Route path="/festival/vishnu-avatar" element={<Vishnu/>} />
           <Route path="/festival/dashavatra" element={<Dash/>} />
           <Route path="/festival/tamil" element={<TamilFest/>} />
           <Route path="/festival/malayalam" element={<MalyalamFest/>} />
            <Route path="/festival/sankranti" element={<SankrantiFest/>} />
            <Route path="/festival/navdurga" element={<NavDurga/>} />
            <Route path="/festival/puja-vidhi" element={<PujaVidhi/>} />
            <Route path="/festival/deities" element={<Deities/>} />
            <Route path="/festival/gurus-saints" element={<Gurus/>} />
           <Route path="/festival/top10" element={<TopFest/>} />
           <Route path='/Love-Horoscope' element={<LoveHoro/>}/>
           <Route path='/career-counselling' element={<Careerr/>}/>
           <Route path='/Learn-astrology' element={<Learn/>}/>
           <Route path='/Gemstone' element={<Gemstone/>}/>
           <Route path='/ephemeris' element={<Ephemeris/>}/>
           <Route path='/ephemeris/extended' element={<ExtendedEphemeris/>}/>

           </Route>

            <Route path="/admin/dashboard" element={<Admin/>}/>
            <Route path="/class-schedule" element={<Schedule/>}/>
            <Route path="/feedback-testimonial" element={<FeedbackTestimonial/>}/>

            <Route path="/blog" element={<AstroBlog />} />
             <Route path="/privacy" element={<PrivacyPolicy />} />
             <Route path="/terms" element={<TermsAndConditions />} />
             <Route path="/refund" element={<RefundPolicy />} />
             <Route path="/about-us" element={<About/>} />
             <Route path="/chart" element={<Chart />} />
             <Route path="/arati" element={<Arti />} />
            

            <Route path="/jyotish/janma-kundali/main-page" element={<Layout />}>
               {/* Nested routes under Layout */}
              <Route index element={<Basic/>} /> {/* default route */}
              <Route path='basic-details' element={<BasicDetails/>}/>
              <Route path='planet-pos' element={<PlanetPos/>}/>
              <Route path='chalit' element={<Chalit/>}/>
              <Route path='pras' element={<Pras/>}/>
              <Route path='ashtak' element={<Ashtak/>}/>
              <Route path='aspect' element={<Aspect/>}/>
              <Route path='Friends' element={<Friends/>}/>
              <Route path='Bhav-Madhya' element={<Madhya/>}/>
              <Route path='shad-bhav' element={<ShadBhav/>}/>
              <Route path='D1-to-D16' element={<AllChart/>}/>
              <Route path='Transit-Today' element={<TransitToday/>}/>

              <Route path='life' element={<Life/>}/>
              <Route path='love' element={<Love/>}/>
              <Route path='career' element={<Career/>}/>
              <Route path='nature' element={<Nature/>}/>

              <Route path="lucky" element={<NumberPage type="lucky" />} />
              <Route path="unlucky" element={<NumberPage type="unlucky" />} />
              <Route path="destiny" element={<NumberPage type="destiny" />} />
              <Route path="lifepath" element={<NumberPage type="lifepath" />} />
              <Route path="chineselucky" element={<NumberPage type="chineselucky" />} />


              <Route path="vim" element={<VimshottariLinks/>}/>
              <Route path="vimshottari-md-ad" element={<Mdad/>}/>
              <Route path="vimshottari-ad-pd-1" element={<Adpd1/>}/>
              <Route path="vimshottari-ad-pd-2" element={<Adpd2/>}/>
              <Route path="vimshottari-ad-pd-3" element={<Adpd3/>}/>
              <Route path="vimshottari-ad-pd-4" element={<Adpd4/>}/>
              <Route path="vimshottari-ad-pd-5" element={<Adpd5/>}/>
              <Route path="vimshottari-ad-pd-sd-1" element={<Sd1/>}/>
              <Route path="vimshottari-ad-pd-sd-2" element={<Sd2/>}/>
              <Route path="vimshottari-ad-pd-sd-3" element={<Sd3/>}/>
              <Route path="vimshottari-ad-pd-sd-4" element={<Sd4/>}/>

             <Route path="char" element={<CharDasha/>}/>
             <Route path="yogini" element={<YoginiDasha/>}/>
            </Route>
            </Routes>
            
      </Router>
      )}
    </div>
  );
}

export default App;
